module.exports = __webpack_public_path__ + "media/images/icons/outlined/cloud-sync-ec78fd557f1730467955c666aed7bdf8.svg";